import '../../App.css'
import { useState } from 'react';
import { FaUser } from "react-icons/fa";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../components/AuthContext';
import Appconfig from '../../config/config'
import axios from 'axios';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth()
  const [user_nameValidationError, setUser_NameValidationError] = useState("Please enter username");
  const [passwordValidationError, setPasswordValidationError] = useState("Please enter password");
  const [validationError, setValidationError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [welcomeMessage, setWelcomeMessage] = useState("")
  const [formData, setformData] = useState({
    user_name: '',
    password: '',
    site_code: Appconfig.sitecodes,
    user_type: "Super"
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  function checkValidation() {
    if (formData.user_name.trim() === "") {
      setUser_NameValidationError('Please enter username')
    }
    if (formData.password === "") {
      document.querySelector('.password-error').classList.remove('hidden');
      setPasswordValidationError('Please enter password')
    }
    const regex = /^[a-zA-Z0-9]*$/;
    if (!regex.test(formData.user_name)) {
      document.querySelector('.username-error').classList.remove('hidden');
      setUser_NameValidationError('Username is only allow a-z and 0-9.')
      return false;
    }
    if (regex.test(formData.user_name) && formData.password !== "") {
      return true
    }
  }

  const handleInputChange = (event) => {
    setformData({
      ...formData,
      [event.target.name]: event.target.value
    });
    if (event.target.name === 'user_name') {
      document.querySelector('.username-error').classList.add('hidden');
    }
    if (event.target.name === 'password') {
      document.querySelector('.password-error').classList.add('hidden');
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (checkValidation()) {
      const config = {
        method: 'post',
        url: `${Appconfig.apiUrl}users/userAuthenticate`,
        headers: { 'Content-Type': 'application/json' },
        data: JSON.stringify(formData)
      };

      axios(config)
        .then(function (response) {
          formData.user_name = "";
          formData.password = "";
          if (response.data.result) {
            storeUserinfo(response.data.resultData);
          } else {
            setValidationError(response.data.resultMessage);
            errorNotification();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

  function storeUserinfo(userdata) {
    login(userdata);
    setWelcomeMessage(`Welcome, ${userdata.user_name || formData.user_name}!`);
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      navigate('/');
    }, 4000); // ⏳ 4 seconds for premium effect
  }

  const errorNotification = () => {
    NotificationManager.error('Invalid Login Credential!', '', 3000);
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gradient-to-b from-[#0c9971] to-black min-h-screen px-4">
      {/* Premium Loader */}
      {isLoading && (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-gradient-to-b from-[#0c9971] to-black z-50 animate-fadeIn">
          <svg
            className="animate-spin w-16 h-16 text-[#f9df10] mb-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            ></path>
          </svg>
          <h2 className="text-2xl font-bold text-white">{welcomeMessage}</h2>
          <p className="text-[#f9df10] text-sm mt-2">Loading your dashboard...</p>
        </div>
      )}

      {/* Login Modal */}
      {!isLoading && (
        <div className="w-full max-w-[420px] bg-gradient-to-b from-[#0c9971] to-black rounded-xl shadow-2xl p-8 flex flex-col items-center border border-[#0c9971] animate-fadeIn">
          <img
            src="/logo.png"
            alt="Logo"
            className="w-[160px] h-auto mb-6"
          />

          <form
            method="post"
            onSubmit={handleSubmit}
            autoComplete="off"
            noValidate
            className="w-full flex flex-col gap-4"
          >
            {/* Username */}
            <div>
              <div className="relative flex items-center bg-white rounded-md overflow-hidden">
                <input
                  value={formData.user_name}
                  onChange={handleInputChange}
                  onBlur={(e) => {
                    if (!e.target.value.trim()) {
                      document.querySelector('.username-error').classList.remove('hidden');
                    }
                  }}
                  type="text"
                  name="user_name"
                  placeholder="Username"
                  maxLength={30}
                  autoFocus
                  className="w-full px-4 py-3 text-black text-sm outline-none"
                />
                <button type="button" className="px-3 text-black text-lg">
                  <FaUser />
                </button>
              </div>
              <span className="username-error hidden text-xs text-[#f9df10] mt-1 block">
                {user_nameValidationError}
              </span>
            </div>

            {/* Password */}
            <div>
              <div className="relative flex items-center bg-white rounded-md overflow-hidden">
                <input
                  value={formData.password}
                  onChange={handleInputChange}
                  onBlur={(e) => {
                    if (!e.target.value.trim()) {
                      document.querySelector('.password-error').classList.remove('hidden');
                    }
                  }}
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  minLength={6}
                  className="w-full px-4 py-3 text-black text-sm outline-none"
                />
                <button
                  type="button"
                  className="px-3 text-black text-lg"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </button>
              </div>
              <span className="password-error hidden text-xs text-[#f9df10] mt-1 block">
                {passwordValidationError}
              </span>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full flex items-center justify-center bg-[#f9df10] text-black font-bold text-base rounded-md py-3 hover:bg-yellow-400 transition-all"
            >
              Login
              <svg
                className="ml-2"
                width="12"
                height="12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.71 7.706l1.432-1.604H1.778V4.898h5.39L5.71 3.294l.781-.86L9.278 5.5 6.49 8.565l-.78-.86zM1.12 0C.825 0 .564.124.339.372a1.24 1.24 0 0 0-.339.86v8.536c0 .325.113.611.339.86.225.248.486.372.78.372H8.88c.295 0 .556-.124.781-.372a1.24 1.24 0 0 0 .339-.86V7.333H8.88v2.435H1.12V1.232h7.76v2.435H10V1.232a1.24 1.24 0 0 0-.339-.86C9.436.124 9.175 0 8.881 0H1.12z"
                  fill="currentColor"
                  fillRule="evenodd"
                />
              </svg>
            </button>
          </form>
        </div>
      )}
    </div>
  )
}

export default Login;
